
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/api/image-list",
      function () {
        return require("private-next-pages/material-ui/api/image-list.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/api/image-list"])
      });
    }
  